<template>
  <div class="product_specification">
    <h6 class="prdt_sub_hdng">{{$t('aboutProduct')}}</h6>
    <div class="head">
      <ul>
        <li v-for="(description,index) in list" :key="index" v-if="list.length > 1" class="bullet_points " ><span>*</span> {{ description}}</li>
         <li v-for="(description,index) in list" :key="index" v-if="list.length == 1">{{ SpliteDigits(description)}}
         </li>
      </ul>
      <!-- {{SplitData(details.productDescription)}} -->
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutProduct",
  props: {
    dataAbtPrd: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      details: {},
      list: []
    };
  },
  watch: {
    dataAbtPrd() {
      this.details = this.dataAbtPrd;
      if (this.details.productDescription) {
        this.list = this.details.productDescription.split("\r\n");
      }
    }
  },
  methods: {
    SpliteDigits(data){
      let digit=data.split('1.')
      if(digit.length > 1){
        return data
      }else{
        return '*'+ ' ' + digit
      }
     
    },
    joinGroup(productId) {
      try {
        JSBridgePlugin.joinGroup(JSON.stringify(productId));
      } catch (err) {
        console.log(err);
      }
    }
  },
  mounted() {
    this.details = this.dataAbtPrd;
    if (this.details.productDescription) {
      this.list = this.details.productDescription.split("\r\n");
    }
  }
};
</script>